export const buttons = {
  borderRadius: '5px',
  height: '40px',
  minWidth: '150px',
  padding: '0 20px',
  condensed: {
    height: '30px',
  },
};
